import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";
import FormFormacionReligiosa from "../formularios/form_formacion_religiosa";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class VistaFormacionReligiosa extends Component {
  constructor(props) {
    super(props);
    this.mostrarFormacionReligiosa = this.mostrarFormacionReligiosa.bind(this);
    this.deleteFormacionReligiosa = this.deleteFormacionReligiosa.bind(this);
  }

  //DELETE
  //Implementado en la vista borra aquellos desplegables de desplegables
  deleteFormacionReligiosa(id) {
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/estudiosReligiosos/" + $this[0].props.DatosMonja.datosFormacionReligiosa[id].id,
      method: "DELETE",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha eliminado correctamente", "success");
        $this[0].props.deleteFormacionReligiosa(id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  // Funciona igual que los votos.
  mostrarFormacionReligiosa() {
    let longitud = 0;
    let formacionReligiosa = null;
    let ArrayFormacionReligiosa = [];

    if (this.props.DatosMonja.datosFormacionReligiosa) {
      longitud = this.props.DatosMonja.datosFormacionReligiosa.length;
    }

    // Se crea un bucle que recorre todas las formaciones religiosas de la hermana
    for (let i = 0; i < longitud; i++) {
      formacionReligiosa = null;

      // Se crea la formacion religiosa
      formacionReligiosa = (
        <Container>
          <Row>
            <Col lg="4" className="border">
              <h6>Tipo de estudios</h6>
              <p>{this.props.DatosMonja.datosFormacionReligiosa[i].religiousStudies}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Año</h6>
              <p>{utils.formatDate(this.props.DatosMonja.datosFormacionReligiosa[i].religiousStudiesYear)}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Lugar</h6>
              <p>{this.props.DatosMonja.datosFormacionReligiosa[i].religiousStudiesPlace}</p>
            </Col>
          </Row>
        </Container>
      );

      // Se añade la situacion personal al vector junto con su desplegable y su modal ( va dentro de desplegable )
      // el funcionamiento es igual que en la vista de las etapas de la vida religiosa con los mismos parametros
      ArrayFormacionReligiosa.push(
        <Desplegable
          handleButtonShow={this.props.handleButtonShow}
          showModal={this.props.showModalFormacionReligiosa[i]}
          Toogle={this.props.DatosMonja.datosFormacionReligiosa[i].religiousStudies}
          value={"18"} // Fil para la matriz
          key={this.props.DatosMonja.datosFormacionReligiosa[i].id}
          id={i} // Col para la matriz
          Text={formacionReligiosa}
          deleteFunction={this.deleteFormacionReligiosa}
          Form={
            <FormFormacionReligiosa
              DatosMonja={this.props.DatosMonja}
              setFormacionReligiosa={this.props.setFormacionReligiosa}
              putFormacionReligiosa={this.props.putFormacionReligiosa}
              handleButtonShow={this.props.handleButtonShow}
              id={i}
              setAlert={this.props.setAlert}
            ></FormFormacionReligiosa>
          }
          canEdit={this.props.canEdit}
        />
      );
    }
    if (longitud === 0)
      ArrayFormacionReligiosa.push(
        <p className="ml-3" key="3">
          No hay datos actualmente
        </p>
      );
    return ArrayFormacionReligiosa;
  }
  render() {
    return <React.Fragment>{this.mostrarFormacionReligiosa()}</React.Fragment>;
  }
}
